// Copyright (C) Unite Digital LLC - All Rights Reserved.
// Unauthorized copying of this file, via any medium is strictly prohibited.
// Proprietary and confidential.
// Developed by Unite Digital LLC.

import { Component, OnInit } from '@angular/core';
import { tenantIsStellantis } from 'src/app/utils/utils';
import packageJson from '../../../../package.json';
import { Router } from '@angular/router';

@Component({
    selector: 'buyer-tenant-header',
    templateUrl: './buyer-tenant-header.component.html',
    styleUrls: ['./buyer-tenant-header.component.scss'],
})
export class BuyerTenantHeaderComponent implements OnInit {
    public companyImage: string = null;
    public productImage: string = null;
    public version: string = packageJson.version;

    constructor(private readonly router: Router) {}

    ngOnInit(): void {
        this.setImages();
    }

    private setImages(): void {
        if (tenantIsStellantis()) {
            this.companyImage = '../../assets/img/stellantis-logo-white.png';
            this.productImage = '../../assets/img/ez-docs-logo-white.png';
        } else {
            this.companyImage = '../../assets/img/DDJ-logo-white.png';
            this.productImage = '../../assets/img/cropped-ud-logo-white.png';
        }
    }

    public routeToHome() {
        //Function Routes User to Whatever Their Default Home Page Is

        this.router.navigateByUrl('/main/vehicles');
    }
}
